<template>
    <div class="wrap">
        <div class="d-flex">
            <div class="mr-auto">
                <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
                <slot name="buttons"></slot>
            </div>
            <div class="align-self-end">
                <input-debounced
                        v-model="search"
                        :clearable="true"
                        :autofocus="true"
                        placeholder="Search"
                        class="search-bar w-300 mb-2"
                ></input-debounced>
            </div>
        </div>
        <base-table
                :base-url="urlWithFilters"
                ref="baseTable"
                @load-success="onLoadSuccess"
                @refresh="onRefresh"
                :current-page="currentPage"
                v-loading="isRefreshing"
                element-loading-spinner="el-icon-loading"
        >
            <template v-slot>
                <el-table
                        :data="items"
                        stripe
                        class="w-100"
                >
                    <el-table-column
                        prop="model.id"
                        label="Id"
                        min-width="40"
                    ></el-table-column>
                    <el-table-column
                        prop="model.provider.name"
                        label="Provider"
                        min-width="80"
                        :formatter="formatStringValue"
                    ></el-table-column>
                    <el-table-column
                        prop="model.representative.name"
                        label="Representative"
                        min-width="90"
                        :formatter="formatStringValue"
                    ></el-table-column>
                    <el-table-column
                        prop="model.title"
                        label="Title"
                        min-width="290"
                        :formatter="formatStringValue"
                    ></el-table-column>
                    <el-table-column
                        prop="model.name"
                        label="Name"
                        min-width="200"
                        :formatter="formatStringValue"
                    ></el-table-column>
                    <el-table-column
                        prop="model.brand.title"
                        label="Brand"
                        min-width="120"
                    ></el-table-column>
                    <el-table-column
                        label="Phone number"
                        min-width="120"
                        v-slot="{row}"
                    >
                        <phone-number-column :row="row"></phone-number-column>
                    </el-table-column>
                    <el-table-column
                        prop="model.email_address.address"
                        label="Email Address"
                        min-width="200"
                        :formatter="formatStringValue"
                    ></el-table-column>
                    <el-table-column
                        prop="user_count"
                        label="Users"
                        min-width="120"
                        v-slot="{row}"
                    >
                        <user-count-column :row="row"></user-count-column>
                    </el-table-column>
                    <el-table-column
                        prop="conversation_count"
                        label="Conversations"
                        min-width="120"
                        v-slot="{row}"
                    >
                        <conversation-count-column :row="row"></conversation-count-column>
                    </el-table-column>
                    <el-table-column
                        prop="model.created_at"
                        label="Created at"
                        min-width="120"
                        :formatter="formatDate"
                    ></el-table-column>
                    <el-table-column
                        label="Actions"
                        v-slot="{row}"
                    >
                        <actions-column :row="row" @edit="onEdit" @delete="onDelete"></actions-column>
                    </el-table-column>
                </el-table>
            </template>
        </base-table>
        <el-pagination
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                class="text-right"
        ></el-pagination>
    </div>
</template>

<script>
  import TableWithPagination from '../table-with-pagination';
  import {addQueryParams} from '../../libs/url';
  import ActionsColumn from './actions-column';
  import ConversationCountColumn from './conversation-count-column';
  import UserCountColumn from './user-count-column';
  import PhoneNumberColumn from "./phone-number-column";

  export default {
    extends: TableWithPagination,

    components: {
      ActionsColumn,
      ConversationCountColumn,
      UserCountColumn,
      PhoneNumberColumn,
    },

    data() {
      return {
        search: null,
        filters: {},
      };
    },

    computed: {
      /**
       * @return {string}
       */
      urlWithFilters() {
        return addQueryParams(this.url, this.filters);
      },
    },

    watch: {
      search: function (value) {
        this.filters = value
        ? _.assign({}, this.filters, {search: value})
          : _.omit(this.filters, ['search']);
      },
    },

    methods: {
      /**
       * @param {object} row
       * @param {object} col
       * @param {string} datetime
       */
      formatDate(row, col, {datetime}) {
        return moment(datetime).format(config('format.moment.short.datetime'));
      },

      /**
       * @param {object} row
       * @param {object} col
       * @param {string} value
       * @return {string}
       */
      formatStringValue(row, col, value) {
        return !_.isNull(value) ? value : '--';
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.baseTable.refresh();
      },

      /**
       * @param {string} url
       * @event show-add-outgoing-number-dialog
       */
      onEdit({url}) {
        eventBus.$emit('show-add-outgoing-number-dialog', url);
      },

      /**
       * @param {string} url
       */
      onDelete({url}) {
        axios.post(url, {_method: 'DELETE'})
          .then(({data: {message}}) => {
            _.isString(message) && this.$message.success(message);
            this.refresh();
          })
          .catch((err) => {
            const message = _.get(err, 'response.data.message');
            _.isString(message) && this.$message.error(message);
          });
      }
    }
  }
</script>
